import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }) => ({
  tooltip: {
    marginTop: -10,
    background: custom.grey[3],
    fontSize: 12,
    fontWeight: 'bold',
    padding: '10px 15px',
  },
  controlWrapper: {
    position: 'relative',
    display: 'flex',
  },
  mobileWrapper: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
  },
}));
